export default __webpack_public_path__ + "static/media/FCP.f373ce0f.png";